import React from 'react';

export function OnboardingPage() {
  return (
    <div>
      <h1>Onboarding</h1>
      <p>Onboarding wizard coming soon...</p>
    </div>
  );
}